

// const BASE_URL = "https://staging.pteshstudios.com";
import "./NewEngineering.css";
import "./serviceEditor.css";
import { NavLink } from "react-router-dom";
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";

const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

const DEFAULT_DATA = {
  bannerImage: "",
  bgImage: "",
  title: "We bring together experienced engineers, project managers, and technical experts who are passionate about solving complex engineering challenges and delivering long-lasting solutions.",
  paragraphs: [
    "Jeyshawn Engineering Limited provides comprehensive engineering services across the oil & gas, energy, and industrial sectors. Our engineering solutions are underpinned by deep technical expertise, rigorous quality assurance, and a commitment to delivering projects that meet international standards.",
    "Our multidisciplinary team covers concept development, detailed design, FEED studies, technical studies, and engineering support for all phases of project execution. We integrate engineering excellence with practical field experience to deliver fit-for-purpose solutions.",
    "From feasibility studies and front-end engineering to detailed design and post-construction support, our engineering services are tailored to the specific requirements of each client and project.",
  ],
  sections: [],
};

export default function Engineering() {
  const { pageData, loading, fetchErr, fetchData, modalOpen, setModalOpen, saving, handleSave, saveMsg } =
    usePageEditor("/api/engineering", DEFAULT_DATA);

  const bannerImg = resolveUrl(pageData.bannerImage) || null;
  const bgImg     = resolveUrl(pageData.bgImage)     || null;

  return (
    <>
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={fetchData}>Retry</button></div>}
      {modalOpen && (
        <ServiceEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} pageLabel="Engineering" />
      )}

      {bannerImg && (
        <div className="img_carrier">
          <img src={bannerImg} alt="" />
        </div>
      )}

      <section className="service-detail" style={bgImg ? { backgroundImage: `url(${bgImg})` } : {}}>
        <div className="service-detail__layout">
          <div className="service-detail__content">
            <h2 className="service-detail__title">{pageData.title}</h2>
            <span className="service-detail__divider" />
            {pageData.paragraphs.map((p, i) => <p key={i} className="service-detail__intro">{p}</p>)}
            {pageData.sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => <li key={j} className="service-detail__list-item">{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink key={s.href} to={s.href} className={({ isActive }) => `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`}>
                {s.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
